import axios from 'axios';
import { ApiError } from 'src/error/customError/ApiError';
export const axiosErrorHandler = (e: any): ApiError | Error => {
  if (
    axios.isAxiosError(e) &&
    e.response &&
    e.response.data.code &&
    e.config.headers['X-Request-Id']
  ) {
    const errorObj = {
      code: e.response.data.code,
      message: e.response.data.message,
      detail: e.response.data.message,
      type: e.response.data.type,
      requestId: e.config.headers['X-Request-Id'],
    };
    return new ApiError(errorObj);
  }
  return new Error(e);
};
